/**
 * La taille de `<SamTile>`, que la miniature du duo lit pour en tirer sa superposition
 * (`organisms/LiveTandemBubble/tandemBubbleGeometry.ts`). Pure : elle se lit sous Jest.
 */

/** La plus grande des quatre tailles du livre (72 · 54 · 44 · 34), et celle de l'ancienne tuile. */
export const SAM_TILE_SIZE = 72
